<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component v-if="item.name === '1'" :is="item.content" :ref="item.ref" @addTab="addTab()" @removeTab="removeTab(item.name)"></component>
      <component v-else :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor="26"></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import filters from '../method/filter.js'
import {mapState} from 'vuex'
import ZjwzLB from '../assembly/ZjwzLB.vue'
import MthzLB from '../assembly/MthzLB.vue'
import HyzjLB from '../assembly/HyzcLB.vue'
import DmdxLB from '../assembly/DmdxLB.vue'
import ComboBox from '../assembly/ComboBox.vue'
import Classification from '../assembly/Classification.vue'
export default {
  mixins: [filters],
  components: {
    ZjwzLB,
    MthzLB,
    HyzjLB,
    DmdxLB,
    ComboBox,
    Classification
  },
  data()
  {
    return {
      selectList:
      [
        {value: 'type', name: '所属分类', parentdispc: '', dispc: '', tableData: []}
      ],
      //tab页默认选中
      activeName: 'second',
      editableTabsValue: '1',
      editableTabs: [
        {
          title: '专家文章发布列表',
          name: '1',
          closable: false,
          content: ZjwzLB
        },
        {
          title: '媒体合作发布列表',
          name: '2',
          closable: false,
          content: MthzLB
        },
        {
          title: '会员之家发布列表',
          name: '3',
          closable: false,
          content: HyzjLB
        },
        {
          title: '东盟地学审核列表',
          name: '4',
          closable: false,
          content: DmdxLB
        }
      ]
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName,
      nodeid: state => state.NavID
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.activeName = nval.activeName
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //添加下拉值
    onSubmit(obj)
    {
      let params =
      {
        cmd: 'add',
        _major: 99,
        _minor: 20,
        retAtt: 1,
        moduleid: this.nodeid,
        dispc: obj.dispc,
        colname: obj.value,
        major: 11,
        minor: 26,
        glid: obj.parentdispc || 0
      }
      window.post.getPost(params).then(res =>
      {
        if (res instanceof Object)
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
      })
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/ToQtRelease.vue